<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="商品编号：">
                    <el-input size="default" v-model.trim="formInline.cargoNo" maxlength="60" style="width:160px;" clearable placeholder="关键词" @change="search"></el-input>
                </el-form-item>
<!--                <el-form-item label="状态：">
                    <el-select v-model="formInline.status" placeholder="请选择" clearable @change="search">
                        <el-option
                                v-for="item in statusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="创建时间：" v-if="showOtherSearch">
                    <el-date-picker
                            style="width:350px"
                            v-model="timers"
                            type="datetimerange"
                            @change="timeChange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=""><el-button  @click="search" type="primary" icon="Search" v-show="hasPermission(route.name,'Search')">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="handleEdit('','reset')" icon="Refresh">重置</el-button></el-form-item>
<!--                <el-form-item label=""><el-button  @click="deleteAlllogs" type="danger" v-show="hasPermission(route.name,'goback')">返回上一页</el-button></el-form-item> -->
                <el-form-item label="" @click="clickMore" v-if="!showOtherSearch">
                    <span class="lysearchmore">展开
                        <el-icon><ArrowDown /></el-icon>
                    </span>
                </el-form-item>
                <el-form-item label="" @click="clickMore" v-if="showOtherSearch">
                    <span class="lysearchmore">收起
                        <el-icon><ArrowUp /></el-icon>
                    </span>
                </el-form-item>
            </el-form>
        </div>
        <el-table  :height="tableHeight"  border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
            <el-table-column type="index" width="60" align="center" label="序号">
                <template #default="scope">
                    <span v-text="getIndex(scope.$index)"></span>
                </template>
            </el-table-column>
            <el-table-column min-width="150" prop="cargoNo" label="商品编码" show-overflow-tooltip></el-table-column>
              <el-table-column width="90" prop="qty" label="入库数量" show-overflow-tooltip></el-table-column>
			<el-table-column width="90" prop="outqty" label="出库数量" show-overflow-tooltip></el-table-column>
          <el-table-column width="90" prop="color" label="商品颜色" show-overflow-tooltip></el-table-column>
          <el-table-column width="90" prop="size" label="商品尺寸" show-overflow-tooltip></el-table-column>
          
          <el-table-column width="160" prop="receiver" label="采购员" show-overflow-tooltip></el-table-column>
          <el-table-column min-width="160" prop="inwuliu" label="入库物流单号" show-overflow-tooltip></el-table-column>
          <el-table-column min-width="160" prop="amount" label="总额单价" >
			   <template #default="scope">{{ FormatMoney(scope.row.amount) }}</template>			  
		  </el-table-column>
           <el-table-column min-width="160" prop="price" label="采购单价" >
			    <template #default="scope">{{ FormatMoney(scope.row.price) }}</template>
		   </el-table-column>
          
          <el-table-column width="100" label="仓位">
              <template #default="scope">
                  <el-tag v-if="scope.row.currency==='RMB'" type="success">国内</el-tag>
                  <el-tag v-else type="danger">香港</el-tag>
          
              </template>
          </el-table-column>
          
<!--          
          <el-table-column width="100" label="结算状态">
              <template #default="scope">
                  <el-tag v-if="scope.row.goodStatus===0" type="success">待结算</el-tag>
                  <el-tag v-else type="danger">已结算</el-tag>
          
              </template>
          </el-table-column> -->
			
			<!-- <el-table-column width="90" prop="body" label="请求数据">
                <template #default="scope">
                    <div>
                      <el-popover v-if="scope.row.body" placement="left-start" trigger="click" width="450px">
                        <div class="lypopoverbox">
                          <pre>{{ formatBody(scope.row.body) }}</pre>
                        </div>
                        <template #reference>
                          <el-icon style="cursor: pointer;"><warning /></el-icon>
                        </template>
                      </el-popover>
                      <span v-else>无</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="70" label="状态码">
                <template #default="scope">
                    <el-tag :type="scope.row.code === 200?'success':'warning'">{{ scope.row.code }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column width="90" prop="resp" label="返回信息">
                <template #default="scope">
                    <div>
                      <el-popover v-if="scope.row.resp" placement="left-start" trigger="click" width="450px">
                        <div class="lypopoverbox">
                          <pre>{{ formatBody(scope.row.resp) }}</pre>
                        </div>
                        <template #reference>
                          <el-icon style="cursor: pointer;"><warning /></el-icon>
                        </template>
                      </el-popover>
                      <span v-else>无</span>
                    </div>
                </template>
            </el-table-column> -->
           <!-- <el-table-column min-width="160" label="操作人" show-overflow-tooltip>
                <template #default="scope">
                    <div v-if="scope.row.user_id !=0">{{ scope.row.user.username }}({{ scope.row.user.name }})</div>
                </template>
            </el-table-column> -->
            <el-table-column width="180" prop="created_at" label="创建时间" show-overflow-tooltip>
                <template #default="scope">{{ formatDateTime(scope.row.createTime) }}</template>
            </el-table-column>
<!--            <el-table-column label="操作" fixed="right" width="120">
                <template #header>
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div>操作</div>
                        <div @click="setFull">
                            <el-tooltip content="全屏" placement="bottom">
                                <el-icon ><full-screen /></el-icon>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
                
            </el-table-column> -->
        </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script setup>
    import {ref,reactive,onMounted,onBeforeUnmount,nextTick} from 'vue'
    import { ElMessage,ElMessageBox } from 'element-plus';
    import {outStoreDetailManage,systemOperationlogDelete,systemOperationlogDeletealllogsDelete} from '@/api/api'
    import Pagination from "@/components/Pagination";
    import {dateFormats,hasPermission,formatDateTime,FormatMoney} from "@/utils/util";
    import useTableHight from '@/mixins/useTableHight';
    import { useRouter,useRoute } from 'vue-router'
	
	import router from '@/router/index.js'
    const route = useRoute()

	  
    let statusList = ([
		{id:0,name:'待入库'},
        {id:1,name:'部分入库'},
		{id:2,name:'已入库'},
        {id:9,name:'撤销'},
    ])
    let isFull = ref(false)
    let orderStatic = ref(null)
    let tableSelect = ref(null)
    let tableHeight = useTableHight(orderStatic,tableSelect,isFull.value)
    let loadingPage = ref(false)
    let showOtherSearch = ref(false)//隐藏过长的搜索条件
    let formInline = ref({
        page: 1,
        limit: 10,
    })
    let pageparm = ref({
        page: 1,
        limit: 10,
        total: 0
    })
    let tableData = ref([])

    let timers = ref([])
    function setFull(){
        isFull.value=!isFull.value
        window.dispatchEvent(new Event('resize'))
    }
    // 表格序列号
    function getIndex($index) {
        // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
        return (pageparm.value.page-1)*pageparm.value.limit + $index +1
    }
    const formatBody = (value) => {
        try {
            return JSON.parse(value)
        } catch (err) {
            return value
        }
    }

    function clickMore(){
        showOtherSearch.value = !showOtherSearch.value
        window.dispatchEvent(new Event('resize'))
    }


    function callFather(parm) {
        formInline.value.page = parm.page
        formInline.value.limit = parm.limit
        getData()
    }
    function search() {
		formInline.value.outStoreId=0
        formInline.value.page = 1
        formInline.value.limit = 10
        getData()
    }
    function timeChange(val){
        if (val) {
            formInline.value.beginAt=dateFormats(val[0],'yyyy-MM-dd hh:mm:ss');
            formInline.value.endAt=dateFormats(val[1],'yyyy-MM-dd hh:mm:ss');
        } else {
            formInline.value.beginAt = null
            formInline.value.endAt = null
        }
        search()
    }
    function getData() {
        loadingPage.value = true
	
        outStoreDetailManage(formInline.value).then(res => {
            loadingPage.value = false
            if(res.code ==2000) {
                tableData.value = res.data.data
                pageparm.value.page = res.data.page;
                pageparm.value.limit = res.data.limit;
                pageparm.value.total = res.data.total;
            }
        })
    }
	function goback(){
	 	router.go(-1);
	 }
	 
	 // export default {
	 //   setup() {
	 //     const route = useRoute();
	 //     onMounted(() => {
	 //       console.log(route.params.taskId); // 'value1'

	 //     });
	 //   }
	 // }
    onMounted(()=>{
		formInline.value.outStoreId=route.query.taskId;
		
		console.log(route)
		console.log(formInline.value.outStoreId)
        getData()
    })
</script>

<style scoped>
    .lypopoverbox {
        background: #132738;
        color: #c26a3e;
        height: 560px;
        width: 425px;
        overflow: auto;
    }
    .lypopoverbox::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
</style>